class InfiniteScroll extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        // Defaults keep the collection and search grids working untouched.
        this.containerSelector = this.dataset.container || '#product-grid';
        this.itemSelector = this.dataset.item || '.grid__item';

        this.container = this.querySelector(this.containerSelector);
        this.trigger = this.querySelector('#infinite-scroll-trigger');
        this.spinner = this.trigger?.querySelector('.loading-spinner');
        this.isLoading = false;

        if (!this.container || !this.trigger) return;

        this.observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !this.isLoading) {
                    this.loadNextPage();
                }
            },
            { rootMargin: '0px 0px 600px 0px' }
        );

        this.observer.observe(this.trigger);
    }

    async loadNextPage() {
        const nextUrl = this.trigger.dataset.nextUrl;
        if (!nextUrl) return;

        this.isLoading = true;
        if (this.spinner) {
            this.spinner.style.display = 'block';
            this.spinner.style.opacity = '0';
            this.spinner.style.transition = 'opacity 0.3s ease-in';
            void this.spinner.offsetWidth;
            this.spinner.style.opacity = '1';
        }

        try {
            const response = await fetch(nextUrl);
            const text = await response.text();
            const html = new DOMParser().parseFromString(text, 'text/html');

            if (this.spinner) {
                this.spinner.style.opacity = '0';
                this.spinner.style.transition = 'opacity 0.3s ease-out';
                await new Promise(resolve => setTimeout(resolve, 300));
            }

            const newItems = html.querySelectorAll(`${this.containerSelector} ${this.itemSelector}`);
            newItems.forEach((item, index) => {
                item.style.opacity = '0';
                item.style.transform = 'translateY(20px)';
                item.style.transition = 'opacity 0.5s ease-out, transform 0.5s ease-out';

                this.container.appendChild(item);

                setTimeout(() => {
                    item.style.opacity = '1';
                    item.style.transform = 'translateY(0)';
                }, 50 + (index * 50));
            });

            const newTrigger = html.getElementById('infinite-scroll-trigger');
            if (newTrigger && newTrigger.dataset.nextUrl) {
                this.trigger.dataset.nextUrl = newTrigger.dataset.nextUrl;
            } else {
                this.observer.unobserve(this.trigger);
                this.trigger.remove();
            }
        } catch (error) {
            console.error('Error loading next page:', error);
        } finally {
            this.isLoading = false;
            if (this.spinner) {
                this.spinner.style.display = 'none';
                this.spinner.style.opacity = '1';
            }

            // The observer only reports state CHANGES. When the new items are
            // not tall enough to push the trigger out of the root margin it
            // stays intersecting, no further callback arrives and the scroll
            // stalls until the reader moves away and back. Re-observing forces
            // a fresh reading of the current state, so the next page loads on
            // its own if the trigger is still in view.
            if (this.trigger.isConnected) {
                this.observer.unobserve(this.trigger);
                this.observer.observe(this.trigger);
            }
        }
    }
}

customElements.define('infinite-scroll', InfiniteScroll);
